import { Accordion, AccordionItem, Button, Column, Grid } from "@carbon/react";
import { Add, ArrowRight } from "@carbon/react/icons";

import personIcon from "../../assets/icons/person-danger.svg";
import houseIcon from "../../assets/icons/house.svg";
import mailIcon from "../../assets/icons/mail.svg";
import cardSwipeIcon from "../../assets/icons/cardSwipe.svg";

export const SetupAccordion = () => {
  return (
    <Accordion>
      <AccordionItem
        title={
          <>
            <span className="font-ctm--bold">Welcome to SwitchApp</span>
            <p className="accordion-description font-ctm--regular">
              You’re almost there — our guide will help you complete your
              Business profile and you’ll start receiving payments. Click this
              banner to complete your set-up
            </p>
          </>
        }
        className="welcome-accordion"
      >
        <Grid fullWidth>
          <Column sm={4} md={8} lg={{ span: 15, offset: 1 }} className="">
            <Grid>
              <Column sm={4} md={8} lg={16} className="">
                <h5 className="description-heading font-ctm--bold">
                  Set up your account
                </h5>
              </Column>

              <Column sm={4} md={4} lg={8} className="switchapp-setup--details">
                <div className="setup-section--icon">
                  <img src={personIcon} alt="person icon" />
                </div>

                <p className="setup-section--title font-ctm--semibold">
                  <strong>
                    Complete you activation to start accepting payments
                  </strong>
                </p>

                <p className="setup-section--description font-ctm--regular">
                  Fill out your personal and business details, so we can provide
                  specific information about how SwitchApp can work for your
                  business.
                </p>

                <Button
                  size="sm"
                  className="switchapp-themed setup-button"
                  renderIcon={() => <ArrowRight />}
                >
                  Continue activation
                </Button>
              </Column>

              <Column sm={4} md={4} lg={8} className="switchapp-setup--details">
                <div className="setup-section--icon">
                  <img src={mailIcon} alt="email icon" />
                </div>

                <p>
                  <strong>
                    Complete Confirm your email to use your account
                  </strong>
                  <br />
                  Click on the confirmation link we sent to
                  olasunkanmifinesse@gmail.com. If you don’t see it in your
                  inbox, you may want to check your spam folder.
                </p>
                <Button
                  size="sm"
                  className="switchapp-themed setup-button"
                  renderIcon={() => <ArrowRight />}
                >
                  Resend confirmation email
                </Button>
              </Column>

              <Column sm={4} md={4} lg={8} className="switchapp-setup--details">
                <div className="setup-section--icon">
                  <img src={houseIcon} alt="bank icon" />
                </div>

                <p>
                  <strong>
                    Complete Link a bank to move your money as soon as you get
                    paid
                  </strong>
                  <br />
                  Once your bank is confirmed, you’ll be able to move money from
                  your SwitchApp account right to your bank account.
                </p>
                <Button size="sm" className="switchapp-themed setup-button">
                  Choose a bank account
                </Button>
              </Column>

              <Column sm={4} md={4} lg={8} className="switchapp-setup--details">
                <div className="setup-section--icon">
                  <img src={cardSwipeIcon} alt="swiping card icon" />
                </div>

                <p>
                  <strong>
                    Complete Add Payment gateway services for your business, for
                    your customers to make payments.
                  </strong>
                  <br />
                  Fill in your personal and business details, so we can provide
                  specific information about how Switch App can work for your
                  business.
                </p>

                <Button size="sm" className="switchapp-themed setup-button">
                  <Add />
                  Generate QR Code
                </Button>
              </Column>
            </Grid>
          </Column>
        </Grid>
      </AccordionItem>
    </Accordion>
  );
};
